<template>
  <div class="highchart-container">
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'FilterLifeGraph',
  mixins: [unitPreferencesMixin],
  props: {
    dailyStats: Array,
  },
  computed: {
    graphData() {
      const {
        partnerSettings: {
          DATE_FORMAT = 'MM-DD-YYYY',
        }
      } = this.$store.state.admin;

      let sensor;
      const columnDate = [];
      const filterLifeData = new Map();
      let lifeArray = [];

      this.dailyStats.forEach((c) => {
        const {
          localDate,
          filterLife,
        } = c;
        if (filterLife) {
          Object.entries(filterLife).forEach(([key, value]) => {
            sensor = `Sensor-${key}`;
            if (!filterLifeData.has(sensor)) {
              filterLifeData.set(sensor, []);
            }
            if (value) {
              lifeArray = filterLifeData.get(sensor);
              lifeArray.push(Number(value) * 100);
              filterLifeData.set(sensor, lifeArray);
            } else {
              lifeArray = filterLifeData.get(sensor);
              lifeArray.push(value);
              filterLifeData.set(sensor, lifeArray);
            }
          });
        } else {
          filterLifeData.forEach((value, key, map) => {
            lifeArray = value;
            lifeArray.push(null);
            map.set(key, lifeArray);
          });
        }
        let date = moment(localDate).format('M/D/YYYY');
        if (DATE_FORMAT === 'DD-MM-YYYY') {
          date = moment(localDate).format('D/M/YYYY');
        }
        columnDate.push(date);
      });

      return {
        columnDate,
        filterLifeData,
        sensor,
      };
    },
    chartOptions() {
      const {
        columnDate,
        filterLifeData,
        sensor,
      } = this.graphData;

      const {
        dateFormat,
      } = this;
      const seriesArray = [];
      filterLifeData.forEach((filterLife, sensor) => {
        seriesArray.push(
          {
            type: 'line',
            yAxis: 0,
            xAxis: 0,
            name: sensor,
            color: '#4979FF',
            data: filterLife,
          },
        );
      });
      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Filter Life',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          reversed: new Date(columnDate[0]) > new Date(columnDate[columnDate.length - 1]),
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [{
          labels: {
            format: '{value} %',
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Percentage',
            style: {
              color: 'white',
            },
          },
          min: 0,
          max: 100,
          opposite: false,
        }],
        legend: {
          itemStyle: {
            color: 'white',
          },
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
        },
        series: seriesArray,
      };
    },
  },
};
</script>
